import { FormFields } from '@core/data-access/models/form/form-store.model';
import { Person } from '@core/data-access/models/person.model';
import { SavedTicketHolders } from '@core/features/account/features/saved-ticket-holders/models/saved-ticket-holders.store.model';
import {
  AddTicketHolder,
  AddTicketHolderAndSetFormFields,
  AssignTicketHolder,
  DeleteUploadedTicketHolderCVDocuments,
  SetSendToOwnerFormField,
  SetTicketHolderFields,
  SetTicketHolderFormsAndQuestionnaireDynamicFormFields,
  TicketHolderQuestionnaireDynamicFields,
  UnassignTicketHolder,
  UpdateBuyerTicketHolderToSavedBuyerTicketHolder,
  UpdateTicketHoldersToSavedTicketHolders,
  UploadTicketHolderCVDocuments
} from '@core/features/ticket-assignment/models/ticket-assignment-store.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TariffUuid, TariffUuids } from '@products/models/tariff.model';

export const TicketAssignmentActions = createActionGroup({
  source: 'Ticket assignment',
  events: {
    'Set ticket holder forms and questionnaire dynamic fields on added feature':
      props<SetTicketHolderFormsAndQuestionnaireDynamicFormFields>(),
    'Add ticket holder forms': (tariffUuids: TariffUuids) => ({ tariffUuids }),
    'Add ticket holder forms and questionnaire dynamic fields':
      props<SetTicketHolderFormsAndQuestionnaireDynamicFormFields>(),
    'Add ticket holder questionnaire form on ticket holder assign': (person: Person, formFields: FormFields) => ({
      person,
      formFields
    }),
    'Remove ticket holder questionnaire form on ticket holder assign': emptyProps(),
    'Add ticket holder questionnaire forms on sending option change': (
      tariffUuids: TariffUuids,
      savedTicketHolders: SavedTicketHolders
    ) => ({ tariffUuids, savedTicketHolders }),
    'Remove ticket holder questionnaire forms on sending option change': (tariffUuids: TariffUuids) => ({
      tariffUuids
    }),
    'Remove ticket holder forms': (tariffUuids: TariffUuids) => ({ tariffUuids }),
    'Set selected tariff uuid': (tariffUuid: TariffUuid) => ({ tariffUuid }),
    'Reset reducer': emptyProps()
  }
});

export const TicketHolderActions = createActionGroup({
  source: 'Ticket holder',
  events: {
    'Add new ticket holder': props<AddTicketHolder>(),
    'Add ticket holder and set form fields': props<AddTicketHolderAndSetFormFields>(),
    'Assign ticket holder': props<AssignTicketHolder>(),
    'Unassign ticket holder': props<UnassignTicketHolder>(),
    'Unassign deleted ticket holder': props<UnassignTicketHolder>(),
    'Update ticket holders to saved ticket holders': props<UpdateTicketHoldersToSavedTicketHolders>(),
    'Update buyer ticket holder to saved buyer ticket holder': props<UpdateBuyerTicketHolderToSavedBuyerTicketHolder>(),
    'Set ticket holder fields': props<SetTicketHolderFields>()
  }
});

export const TicketHolderDocumentActions = createActionGroup({
  source: 'Ticket holder document',
  events: {
    'Upload ticket holder CV documents': props<UploadTicketHolderCVDocuments>(),
    'Delete uploaded ticket holder CV documents': props<DeleteUploadedTicketHolderCVDocuments>()
  }
});

export const TicketHolderDynamicFieldsActions = createActionGroup({
  source: 'Ticket holder dynamic fields',
  events: {
    'Set ticket holder questionnaire dynamic fields': (
      ticketHolderQuestionnaireDynamicFields: TicketHolderQuestionnaireDynamicFields
    ) => ({
      ticketHolderQuestionnaireDynamicFields
    }),
    'Reset ticket holder questionnaire dynamic fields': emptyProps()
  }
});

export const TicketHolderFormActions = createActionGroup({
  source: 'Ticket holder form',
  events: {
    'Set send to owner form field': props<SetSendToOwnerFormField>()
  }
});

export const TicketHolderQuestionnaireFormActions = createActionGroup({
  source: 'Ticket holder questionnaire form',
  events: {}
});
